<template>
  <div :is="tag" v-bind="$attrs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "m-custom-scrollbar",
  props: {
    tag: {
      type: String,
      default: "div"
    },
  },
  mounted() {
    if ($.fn.mCustomScrollbar) {
      $(this.$el).mCustomScrollbar({
        autoHideScrollbar: true,
        theme: 'minimal',
        scrollInertia: 0,
        autoDraggerLength: true,
        mouseWheel: {
          preventDefault: true,
          deltaFactor: 50
        }
      });
    }
  }
}
</script>

<style scoped>

</style>